export default "__VITE_ASSET__BfxaqqbT__"